import React from "react";
import { MWGreen, MWGreenDisabled } from "../Util/Const";

//A button which performs the "onClick-function"
class RoundButton extends React.Component {
  render() {
    return (
      <div
        onClick={this.props?.disabled ? null : this.props.onClick}
        className="roundButton"
        style={{ ...this.props.style,
          backgroundColor: this.props?.disabled ? MWGreenDisabled : MWGreen,
          maxWidth: "200px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          textAlign: "center",
          // marginTop: "40px",
          paddingTop: "1px",
          paddingRight: "10px",
          paddingBottom: "1px",
          paddingLeft: "10px",
          fontSize: "14px",
          color: "#ffff",
          letterSpacing: "2px",
          fontWeight: "300px",
          textTransform: "uppercase",
          borderRadius: "100px",
          borderWidth: "3px",
          borderColor: MWGreen,
          borderStyle: "solid",
          textShadow: "0em 0.1em 0.1em rgb(0 0 0 / 5%)",
          boxShadow: "0px 2px 18px 0px rgb(0 0 0 / 15%)",
          cursor: "default",
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default RoundButton;
